import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../utils/axiosInstance';
import { RoomCard } from './RoomCollection';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './HostProfile.css';

const FALLBACK_IMAGES = [
  'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=85',
  'https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1200&q=85',
  'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?auto=format&fit=crop&w=1200&q=85',
];

const DEFAULT_HOST = {
  id: '',
  full_name: 'Al Buhayra',
  introduction:
    "Hello! I'm Al Buhayra. I take pride in providing clean, comfortable, and well-appointed accommodations for travelers and families. Feel free to browse my listings or message me directly with any questions.",
  customer_image: '',
  customer_date: '2026-10-01',
  ratings: '5.0',
  reviews: 0,
  response_time: 'Within an hour',
  response_rate: 100,
  Identity_verified_status: '1',
  phone_verified_status: '1',
  email: '',
};

const DEFAULT_PROPERTIES = [
  {
    id: 'static-host-room-1',
    title: 'Hill Side Super Deluxe AC Room Rangamati',
    location: 'Rangamati',
    images: [FALLBACK_IMAGES[0]],
    ratings: '5.0',
    guests: 2,
    beds: 1,
    baths: 1,
    price: '2,499',
    priceValue: 2499,
    postDate: '2026-10-03',
  },
  {
    id: 'static-host-room-2',
    title: 'Lake View Superior Deluxe AC Room Rangamati, Kathaltoli',
    location: 'Rangamati',
    images: [FALLBACK_IMAGES[1]],
    ratings: '5.0',
    guests: 2,
    beds: 1,
    baths: 1,
    price: '5,999',
    priceValue: 5999,
    postDate: '2026-10-02',
  },
  {
    id: 'static-host-room-3',
    title: 'Royal Family Lake View Suite at Rangamati | Kathaltoli',
    location: 'Rangamati',
    images: [FALLBACK_IMAGES[2]],
    ratings: '5.0',
    guests: 5,
    beds: 2,
    baths: 1,
    price: '7,999',
    priceValue: 7999,
    postDate: '2026-10-01',
  },
];

class HostProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      host: { ...DEFAULT_HOST },
      properties: [],
      loading: true,
      sortBy: 'featured',
      shareMessage: '',
      actionMessage: '',
    };

    this._isMounted = false;
    this.shareMessageTimer = null;
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchHostProfile(this.getHostId());
  }

  componentDidUpdate(prevProps) {
    const previousId = this.getHostId(prevProps);
    const currentId = this.getHostId(this.props);

    if (previousId !== currentId) {
      this.fetchHostProfile(currentId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.shareMessageTimer) {
      clearTimeout(this.shareMessageTimer);
    }
  }

  getHostId = (props = this.props) => {
    const routeId = props?.match?.params?.id;
    if (routeId) return String(routeId);
    if (props?.hostId) return String(props.hostId);

    if (typeof window !== 'undefined') {
      const match = window.location.pathname.match(/\/host-profile\/([^/?#]+)/i);
      if (match && match[1]) return decodeURIComponent(match[1]);
    }

    return '28';
  };

  getBaseUrl = () => {
    const configuredBase = axios?.defaults?.baseURL || '';
    return configuredBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');
  };

  getAssetUrl = (imageName, folder = 'posts') => {
    if (!imageName || typeof imageName !== 'string') return '';
    const trimmed = imageName.trim();
    if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:')) return trimmed;

    const baseUrl = this.getBaseUrl();
    const relativePath = trimmed.replace(/^\/+/, '');

    if (/^uploads\//i.test(relativePath)) {
      return `${baseUrl}/${relativePath}`;
    }

    return `${baseUrl}/uploads/${folder}/${relativePath}`;
  };

  parseGallery = (gallery) => {
    if (Array.isArray(gallery)) return gallery.filter(Boolean);
    if (typeof gallery !== 'string' || !gallery.trim()) return [];

    try {
      const parsed = JSON.parse(gallery);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  isPublishedProperty = (property) => {
    const status = property?.post_state ?? property?.status;
    if (status === undefined || status === null || status === '') return true;
    return ['1', 'active', 'published', 'public'].includes(String(status).trim().toLowerCase());
  };

  mapProperty = (property, index) => {
    const gallery = this.parseGallery(property.gallery_images);
    const imageNames = [];

    if (property.feature_image) imageNames.push(property.feature_image);
    gallery.forEach((image) => {
      if (image && !imageNames.includes(image)) imageNames.push(image);
    });

    const images = imageNames.length
      ? imageNames.map((image) => this.getAssetUrl(image, 'posts')).filter(Boolean)
      : [FALLBACK_IMAGES[index % FALLBACK_IMAGES.length]];

    const rawPrice = property.sales_price ?? property.regular_price ?? 0;
    const parsedPrice = Number(String(rawPrice).replace(/[^\d.]/g, '')) || 0;
    const postId = property.post_id || property.id || `host-property-${index}`;

    return {
      id: String(postId),
      title: property.title || 'Comfortable stay in Bangladesh',
      location:
        property.category_name?.split(',')[0]?.trim() ||
        property.location ||
        property.real_address ||
        'Bangladesh',
      images,
      ratings: property.ratings || 'New',
      guests: Number(property.adults || property.guests || 0),
      beds: Number(property.beds || property.room_number || 0),
      baths: Number(property.baths || 0),
      price: parsedPrice.toLocaleString('en-BD'),
      priceValue: parsedPrice,
      postDate: property.post_date || '',
    };
  };

  getBooleanStatus = (value, fallback = true) => {
    if (value === undefined || value === null || value === '') return fallback;
    if (typeof value === 'boolean') return value;
    return ['1', 'true', 'yes', 'verified', 'active'].includes(
      String(value).trim().toLowerCase()
    );
  };

  normaliseHost = (record, hostId) => {
    const source = record || {};
    return {
      ...DEFAULT_HOST,
      ...source,
      id: String(source.customer_id || source.user_id || source.id || hostId),
      full_name: source.full_name || source.name || DEFAULT_HOST.full_name,
      introduction:
        source.introduction && String(source.introduction).trim()
          ? this.stripHtml(source.introduction)
          : DEFAULT_HOST.introduction.replace('Al Buhayra', source.full_name || DEFAULT_HOST.full_name),
      customer_image: source.customer_image || source.profile_image || '',
      customer_date: source.customer_date || source.created_at || DEFAULT_HOST.customer_date,
      ratings: source.ratings !== undefined && source.ratings !== null && source.ratings !== ''
        ? source.ratings
        : DEFAULT_HOST.ratings,
      reviews: source.reviews !== undefined && source.reviews !== null && source.reviews !== ''
        ? source.reviews
        : DEFAULT_HOST.reviews,
      response_time: source.response_time || DEFAULT_HOST.response_time,
      response_rate: source.response_rate ?? source.responseRate ?? DEFAULT_HOST.response_rate,
      Identity_verified_status:
        source.Identity_verified_status ?? source.identity_verified_status ?? DEFAULT_HOST.Identity_verified_status,
      phone_verified_status:
        source.phone_verified_status ?? source.Phone_verified_status ?? DEFAULT_HOST.phone_verified_status,
      email: source.email || '',
    };
  };

  stripHtml = (value) => {
    if (typeof value !== 'string') return '';
    return value.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  };

  fetchHostProfile = async (hostId) => {
    this.setState({ loading: true, actionMessage: '' });

    try {
      const response = await axios.get(`/get_customer_posts?id=${encodeURIComponent(hostId)}`);
      const payload = response?.data;
      const records = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.posts)
          ? payload.posts
          : Array.isArray(payload)
            ? payload
            : [];

      if (!this._isMounted) return;

      if (records.length > 0) {
        // The API repeats host/customer information on each property row.
        const hostRecord = payload?.customer || payload?.host || records[0];
        const host = this.normaliseHost(hostRecord, hostId);
        // Only show published/active properties when the API supplies a status.
        // Records without a status field are left visible for API compatibility.
        const visibleRecords = records.filter(this.isPublishedProperty);
        const properties = visibleRecords.map((property, index) => this.mapProperty(property, index));
        this.setState({ host, properties, loading: false });
      } else {
        this.setState({
          host: { ...DEFAULT_HOST, id: String(hostId) },
          properties: DEFAULT_PROPERTIES,
          loading: false,
        });
      }
    } catch (error) {
      // Keep the page usable while the API is unavailable; replace these sample values
      // with live fields as the endpoint begins returning them.
      if (this._isMounted) {
        this.setState({
          host: { ...DEFAULT_HOST, id: String(hostId) },
          properties: DEFAULT_PROPERTIES,
          loading: false,
        });
      }
      // Log only for development diagnostics; no API contract is changed here.
      console.error('Unable to load host profile:', error);
    }
  };

  handleSortChange = (event) => {
    this.setState({ sortBy: event.target.value });
  };

  getSortedProperties = () => {
    const properties = [...this.state.properties];
    const { sortBy } = this.state;

    if (sortBy === 'newest') {
      properties.sort((a, b) => new Date(b.postDate || 0) - new Date(a.postDate || 0));
    } else if (sortBy === 'price-low') {
      properties.sort((a, b) => a.priceValue - b.priceValue);
    } else if (sortBy === 'price-high') {
      properties.sort((a, b) => b.priceValue - a.priceValue);
    }

    return properties;
  };

  showShareMessage = (message) => {
    if (this.shareMessageTimer) clearTimeout(this.shareMessageTimer);
    this.setState({ shareMessage: message });
    this.shareMessageTimer = setTimeout(() => {
      if (this._isMounted) this.setState({ shareMessage: '' });
    }, 2400);
  };

  handleShareProfile = async () => {
    const profileUrl = typeof window !== 'undefined' ? window.location.href : '';
    if (!profileUrl) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(profileUrl);
      } else {
        const temporaryInput = document.createElement('textarea');
        temporaryInput.value = profileUrl;
        temporaryInput.setAttribute('readonly', '');
        temporaryInput.style.position = 'fixed';
        temporaryInput.style.opacity = '0';
        document.body.appendChild(temporaryInput);
        temporaryInput.select();
        const copied = document.execCommand('copy');
        document.body.removeChild(temporaryInput);
        if (!copied) throw new Error('Clipboard copy was not available');
      }
      this.showShareMessage('Profile link copied!');
    } catch (error) {
      this.showShareMessage('Could not copy automatically. Please copy the page URL.');
    }
  };

  handleMessageHost = () => {
    const { host } = this.state;
    if (typeof this.props.onMessageHost === 'function') {
      this.props.onMessageHost(host.id);
      return;
    }

    if (host.email) {
      window.location.href = `mailto:${host.email}?subject=${encodeURIComponent(`Question for ${host.full_name}`)}`;
      return;
    }

    this.setState({ actionMessage: 'Direct messaging is not connected to this profile yet.' });
  };

  getHostingSince = () => {
    const rawDate = this.state.host.customer_date;
    const date = rawDate ? new Date(rawDate) : new Date('2026-10-01');
    if (Number.isNaN(date.getTime())) return 'October 2026 (1 month)';

    const monthName = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    const now = new Date();
    const monthDifference = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
    const months = Math.max(1, monthDifference);
    const duration = months === 1 ? '1 month' : `${months} months`;
    return `${monthName} (${duration})`;
  };

  getRatingLabel = () => {
    const rawRating = this.state.host.ratings;
    if (rawRating === undefined || rawRating === null || rawRating === '') return '5.0';
    const value = String(rawRating).trim();
    if (value.toLowerCase() === 'new') return 'New';
    const numericRating = Number(value);
    return Number.isFinite(numericRating) ? numericRating.toFixed(1) : value;
  };

  getReviewCount = () => {
    const reviews = Number(this.state.host.reviews);
    return Number.isFinite(reviews) && reviews >= 0 ? reviews : 0;
  };

  getHostImage = () => {
    const { customer_image } = this.state.host;
    if (!customer_image) return '';

    // If the API returns only a file name, customer images are assumed to live in
    // uploads/customers. Change the folder here if your backend uses a different one.
    return this.getAssetUrl(customer_image, 'customers');
  };

  renderVerification = (verified, label, icon) => (
    <div className={`host-profile-verification ${verified ? 'is-verified' : 'is-unverified'}`} key={label}>
      <span className="host-profile-verification-icon" aria-hidden="true">
        <i className={`bi ${verified ? 'bi-check-lg' : 'bi-dash-lg'}`} />
      </span>
      <span>{label}</span>
      {icon ? <span className="host-profile-verification-kind">{icon}</span> : null}
    </div>
  );

  render() {
    const { host, loading, sortBy, shareMessage, actionMessage } = this.state;
    const properties = this.getSortedProperties();
    const rating = this.getRatingLabel();
    const reviewCount = this.getReviewCount();
    const identityVerified = this.getBooleanStatus(host.Identity_verified_status, true);
    const phoneVerified = this.getBooleanStatus(host.phone_verified_status, true);
    const hostImage = this.getHostImage();
    const initials = (host.full_name || 'Host')
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();

    return (
      <main className="host-profile-page">
        <div className="host-profile-container">
          <div className="host-profile-topbar">
            <nav className="host-profile-breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span aria-hidden="true">/</span>
              <span>Hosts</span>
              <span aria-hidden="true">/</span>
              <span className="host-profile-breadcrumb-current">{host.full_name}</span>
            </nav>

            <div className="host-profile-share-wrap">
              <button type="button" className="host-profile-share-button" onClick={this.handleShareProfile}>
                <i className="bi bi-share" aria-hidden="true" />
                <span>Share Profile</span>
              </button>
              {shareMessage ? <span className="host-profile-share-feedback" role="status">{shareMessage}</span> : null}
            </div>
          </div>

          <section className="host-profile-overview">
            <aside className="host-profile-sidebar">
              <div className="host-profile-card">
                <div className="host-profile-avatar-wrap">
                  {hostImage ? (
                    <img className="host-profile-avatar" src={hostImage} alt={`${host.full_name} profile`} />
                  ) : (
                    <div className="host-profile-avatar host-profile-avatar-fallback" aria-label={`${host.full_name} avatar`}>
                      {initials || <i className="bi bi-person-fill" aria-hidden="true" />}
                    </div>
                  )}
                </div>
                <h1 className="host-profile-name">{host.full_name}</h1>

                <div className="host-profile-stat-grid">
                  <div className="host-profile-stat">
                    <strong>{properties.length}</strong>
                    <span>Listings</span>
                  </div>
                  <div className="host-profile-stat">
                    <strong>{rating}{rating !== 'New' ? <i className="bi bi-star-fill" aria-label="star" /> : null}</strong>
                    <span>Rating</span>
                  </div>
                  <div className="host-profile-stat">
                    <strong>{reviewCount}</strong>
                    <span>Reviews</span>
                  </div>
                </div>

                <div className="host-profile-verified-list">
                  <h3>Host Confirmed Information</h3>
                  {this.renderVerification(identityVerified, identityVerified ? 'Identity Verified' : 'Identity Not Verified')}
                  {this.renderVerification(phoneVerified, phoneVerified ? 'Phone Verified' : 'Phone Not Verified')}
                </div>
              </div>
            </aside>

            <div className="host-profile-main-info">
              <div className="host-profile-section-eyebrow">Host Information</div>
              <h2 className="host-profile-about-title">About {host.full_name}</h2>
              <div className="host-profile-since">
                <i className="bi bi-calendar3" aria-hidden="true" />
                <span>Hosting on Bookly since {this.getHostingSince()}</span>
              </div>

              <div className="host-profile-intro-card">
                <p className="host-profile-introduction">{host.introduction || DEFAULT_HOST.introduction}</p>
                <div className="host-profile-response">
                  <span className="host-profile-response-icon"><i className="bi bi-clock" aria-hidden="true" /></span>
                  <div>
                    <span className="host-profile-response-label">Response Time</span>
                    <strong>{host.response_time || 'Within an hour'} ({host.response_rate ?? 100}% rate)</strong>
                  </div>
                </div>
              </div>

              <div className="host-profile-message-banner">
                <div className="host-profile-message-copy">
                  <strong>Have questions for this host?</strong>
                  <span>Explore their properties below or send a direct inquiry.</span>
                </div>
                <button type="button" className="host-profile-message-button" onClick={this.handleMessageHost}>
                  <i className="bi bi-chat-square-text" aria-hidden="true" />
                  <span>Message Host</span>
                </button>
              </div>
              {actionMessage ? <p className="host-profile-action-message" role="status">{actionMessage}</p> : null}
            </div>
          </section>

          <section className="host-profile-listings" aria-labelledby="host-profile-listings-title">
            <div className="host-profile-listings-header">
              <div>
                <div className="host-profile-section-eyebrow">{properties.length} {properties.length === 1 ? 'Property' : 'Properties'} Available</div>
                <h2 id="host-profile-listings-title" className="host-profile-listings-title">
                  {host.full_name}'s Listings
                </h2>
              </div>
              <label className="host-profile-sort-label">
                <span className="visually-hidden">Sort properties</span>
                <select value={sortBy} onChange={this.handleSortChange} className="host-profile-sort-select">
                  <option value="featured">Featured / Newest</option>
                  <option value="newest">Newest</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                </select>
              </label>
            </div>

            {loading ? (
              <div className="host-profile-loading" role="status">
                <span className="host-profile-spinner" aria-hidden="true" />
                <span>Loading host profile...</span>
              </div>
            ) : properties.length > 0 ? (
              <div className="row g-4 host-profile-property-grid room-collection-section">
                {properties.map((property) => (
                  <div className="col-12 col-sm-6 col-lg-3" key={property.id}>
                    <RoomCard room={property} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="host-profile-empty">
                <i className="bi bi-house-door" aria-hidden="true" />
                <h3>No properties available yet</h3>
                <p>This host's properties will appear here when available.</p>
              </div>
            )}
          </section>
        </div>
      </main>
    );
  }
}

export default HostProfile;
